import { useContext } from 'react';
import { useDocumentData } from 'react-firebase-hooks/firestore';

import { Context } from '../../../index';

const useUsername = (userId) => {
  const { firestore } = useContext(Context);
  const [user] = useDocumentData(firestore.collection('users').doc(userId));

  return user?.first_name && user?.last_name
    ? `${user.first_name} ${user.last_name}`
    : user?.phone || 'Unnamed user';
};

export default useUsername;
